"use strict";

exports.__esModule = true;
exports.StripeChartHeader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Charts = require("../../Charts");
var _Axis = require("../../Charts/Axis");
var _Core = require("../../Core");
var _Time = require("../../Time");
var _formatDurationAxisTicks = require("../../Charts/StripeChart/formatDurationAxisTicks");
var _UiDesignContext = require("../../Theme/UiDesign/UiDesignContext");
var _dec, _dec2, _class, _StripeChartHeader;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a header for StripeChart.
 */
var StripeChartHeader = exports.StripeChartHeader = (_dec = _Time.ReportingPeriodContext.withContext, _dec2 = _Time.TimeContext.withContext, _dec(_class = _dec2(_class = (_StripeChartHeader = /*#__PURE__*/function (_Component) {
  function StripeChartHeader() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(StripeChartHeader, _Component);
  var _proto = StripeChartHeader.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      hideXAxis = _this$props.hideXAxis,
      reportingPeriod = _this$props.reportingPeriod,
      time = _this$props.time;
    var tickSpacing = this.context && this.context.modern ? 90 : 60;
    var tickCount = Math.max(2, Math.floor(width / tickSpacing));
    if (hideXAxis && reportingPeriod) {
      var scale = (0, _Charts.createIntervalScale)(0, width, reportingPeriod.interval);
      return /*#__PURE__*/_react["default"].createElement(_Axis.Axis, {
        scale: scale,
        width: width,
        height: height,
        tickCount: tickCount,
        orientation: "TOP",
        tickFormat: (0, _formatDurationAxisTicks.formatDurationAxisTicks)(time)
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
      level: 4,
      ellipsize: true
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "StripeChartHeader.headingLabel",
      defaultMessage: "Cycles"
    }));
  };
  return StripeChartHeader;
}(_react.Component), _StripeChartHeader.contextType = _UiDesignContext.UiDesignContext, _StripeChartHeader)) || _class) || _class);